<template>
    <section class="social-blocks-container"
             v-observe-visibility="{
                    callback: visibilitySocial,
                    once: true,
                    intersection: {
                       rootMargin: `150px 0px 0px 0px`
                    }
             }"
    >
        <transition name="fade">
            <div v-if="openSocialMentionUrl" class="mention-wrapper"
                 :style="{order: mentionFlexOrder}"
                 ref="pdpSocialMention" id="pdpSocialMention">
                <Mention :url="openSocialMentionUrl"
                         :is-desktop="true"
                         @close="closeMention"
                         @loaded="scrollToMention"
                />
            </div>
        </transition>
        <div v-if="pageData && pageData.length" v-for="(page, index) in pageData" class="flex-list"
             :style="{order: parseFlexListOrder(index)}"
             :key="'social-page-'+index"
        >
            <Single v-for="item in page.blocks" :class="item.cssClass" :key="'pdp-social-'+item.id" :item="item" @itemClick="openMention($event, index)"/>
        </div>
        <div v-show="nextPage" class="load-observer"
             v-observe-visibility=" nextPage && {
                    callback: loadMore,
                    intersection: {
                      threshold: 0.35
                    }
             }"
        />
        <div v-if="loading" class="flex-list loading-list">
            <div class="prz-blk skeleton-box"/>
            <div class="prz-blk pdp-block-vertical skeleton-box"/>
            <div class="prz-blk pdp-block-vertical skeleton-box"/>
            <div class="prz-blk skeleton-box"/>
            <div class="prz-blk skeleton-box"/>
            <div class="prz-blk skeleton-box"/>
        </div>
    </section>
</template>

<script>

import {storePdp} from '@/store/product-page';
import {isEmpty} from "lodash-es/lodash";

import utilities from '@/Utilities/common';
import baseUrl from "@/api/base-url";
import request from "@/Utilities/httpRequest";
import Single from '@/components/Blocks/Block/Single.vue';
import productPage from "@/api/productPage";


import Vue from 'vue';
import {ObserveVisibility} from 'vue-observe-visibility'

Vue.directive('observe-visibility', ObserveVisibility);

export default {
    storePdp,
    name: 'SocialBlocks',
    components: {
        Single,
        Mention: () => import('@/components/Social/Mention.vue'),

    },
    props: {
        contentUrl: {
            type: String,
            default: () => baseUrl.getUrl('social-network/content')
        },
        groupId: {
            type: String,
            default: undefined
        },
    },
    data() {
        return {
            loading: false,
            perPage: 9,
            // min 4 / max 9 posts per page
            pdpTemplates: [
                ['s'], ['s', 's'], ['s', 's', 's'], // 1, 2 & 3 posts
                ['s', 's', 's', 's'], // 4 posts
                ['s', 'v', 'v', 'v', 's'], // 5 posts
                ['s', 'v', 'v', 's', 's', 's'], // 6 posts
                ['s', 's', 'v', 's', 's', 's', 's'], // 7 posts
                ['s', 'v', 's', 'v', 'v', 'v', 's', 's'], // 8 posts
                ['s', 's', 'v', 's', 's', 'v', 'v', 's', 's'] // 9 posts
            ],
            nextPage: 0,
            pageData: [],
            openSocialMentionUrl: null,
            mentionFlexOrder: 0,
            loadedPages: []
        };
    },

    computed: {
        kStrings() {
            return storePdp.getters.kStrings;
        },
        blocksColor() {
            let blocksColor = storePdp.getters.blocksColor;
            if (!blocksColor) {
                return '#333';
            }

            return blocksColor;
        },
    },
    methods: {
        async load(page = 1) {
            if(this.loadedPages.includes(page)){
                return;
            }
            try {
                if (this.contentUrl) {
                    this.loading = true;
                    let params = {
                        groupId: this.groupId ?? null,
                        type: 'social',
                        perPage: 9,
                        page: page
                    };
                    this.loadedPages.push(page);
                    const {data} = await request.post(this.contentUrl, params);
                    this.addPostsPage(page, data.elements);
                    this.nextPage = data.elements.length ? data.nextpage : null;
                    this.loading = false;
                }

            } catch (e) {
                if (typeof Bugsnag !== 'undefined') {
                    Bugsnag.notify('socialBlocks', e, {}, 'error');
                }
                else {
                    console.error(e.message);
                }
            }
        },
        visibilitySocial(isVisible) {
            if (isVisible) {
                this.load();
            }
        },
        loadMore(isVisible) {
            if (isVisible && this.nextPage) {
                this.load(this.nextPage);
            }
        },
        addPostsPage(page = 1, posts = []) {
            const postsLength = posts.length;
            //if (isEmpty(posts) || postsLength < 4) {
            if (isEmpty(posts)) {
                return;
            }

            const layoutIndex = postsLength <= this.perPage ? postsLength - 1 : this.perPage - 1;
            const template = this.pdpTemplates[layoutIndex];
            const socialBlocks = productPage.socialBlockFactory(posts, template, this.perPage, this.blocksColor);
            const postsPage = {
                page: page,
                blocks: Object.values(socialBlocks),
                //template: template
            };
            //console.log('page template: ', postsPage);
            this.pageData.push(postsPage);
        },
        openMention(block, order = 1) {
            let url = block.extraInfo;
            if(block.blockName){
                url = url + (url.indexOf('?') > 0 ? '&' : '?') + 'oti=' + block.blockName;
            }
            this.openSocialMentionUrl = url;
            this.mentionFlexOrder = 2 * parseInt(order);
            this.$emit('close-modals');
        },
        scrollToMention() {
            let element = document.getElementById('pdpSocialMention');
            if (!element) {
                element = this.$refs.pdpSocialMention.$el;
            }
            //console.log('scroll to elem: ', element);

            if (element) {
                utilities.scrollIntoViewWithOffset(element, 76);
            }
        },
        parseFlexListOrder(index = 0) {
            return 2* parseInt(index) + 1;
        },
        closeMention() {
            this.openSocialMentionUrl = null;
        }
    },
    // watch: {},
    // mounted() {
    // },
};
</script>

<style lang="scss">
//@import "../styles/pdpGrid";
@import '../../../../scss/CalcSize.scss';

.social-blocks-container {
    display: flex;
    flex-direction: column;
    gap: responsive(20px);
    width: 100%;
    height: auto;
}

.mention-wrapper {
    width: 100%;
}

.load-observer {
    display: block;
    width: 100%;
    height: responsive(50px);
    order: 2000;
}

.loading-list {
    order: 100;
}
</style>
